"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _CarouselHeader = require("./CarouselHeader.styles");
/**
 * Wrapper for the Carousel header content including the heading text
 * and navigation controls.
 *
 * @since 8.71.0
 */
var CarouselHeader = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_CarouselHeader.StyledCarouselHeader, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.CarouselHeader = CarouselHeader;
CarouselHeader.displayName = 'CarouselHeader';